import React from 'react';
import PropTypes from 'prop-types'
import styles from './PFSLogo.module.css';

import logoSvg from './pfs_logo.svg';

const PFSLogo = ({ imgSize = 100 }) => (
  <div className={styles.PFSLogo} data-testid="PFSLogo">
    <img alt="PFS Logo" src={logoSvg} width={imgSize} />
  </div>
);

PFSLogo.propTypes = {
  imgSize: PropTypes.number,
};

export default PFSLogo;
